module.exports = __webpack_public_path__ + "static/media/mail-plus.1c955bce.svg";